
//-----------------------|| securities MENU ITEMS ||-----------------------//
export const Admin = {
    id: 'admin',
    title: 'Admin',
    type: 'collapse',
    icon: 'IconUsers',
    children: [
        {
            id: 'auth.view_user',
            title: 'User Mgmt',
            type: 'item',
            url: '/user_profiles',
            icon: 'IconUsers',
            breadcrumbs: false
        },
        {
            id: 'auditlog.view_logentry',
            title: 'Audit Logs',
            type: 'item',
            url: '/audit_logs',
            icon: 'IconFolderSearch',
            breadcrumbs: false
        },
        {
            id: 'masters.view_implementerportalconfig',
            title: 'Settings',
            type: 'item',
            url: '/portal_config',
            icon: 'IconSettings',
            breadcrumbs: false
        }
    ]
};
